import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const Sidebar = () => {
  const location = useLocation();
  const isActive = path => location.pathname === path;

  return (
    <div data-simplebar className="h-100">
      <div id="sidebar-menu">
        <ul className="metismenu list-unstyled" id="side-menu">
          <li className="menu-title">Menu</li>

          <li className={isActive("/dashboard") ? 'mm-active' : ''}>
            <NavLink to="/dashboard" className={({ isActive }) =>
              `waves-effect ${isActive ? 'active' : ''}`
            }>
              <i className="mdi mdi-view-dashboard"></i>
              <span>Dashboard</span>
            </NavLink>
          </li>

          <li className={isActive("/user") ? 'mm-active' : ''}>
            <NavLink to="/user" className={({ isActive }) =>
              `waves-effect ${isActive ? 'active' : ''}`
            }>
              <i className="fas fa-users"></i>
              <span className="ms-2">Member</span>
            </NavLink>
          </li>
          <li className={isActive("/guest") ? 'mm-active' : ''}>
            <NavLink to="/guest" className={({ isActive }) =>
              `waves-effect ${isActive ? 'active' : ''}`
            }>
              <i className="fas fa-user-clock"></i>
              <span className="ms-2">Guest</span>
            </NavLink>
          </li>
          <li className={isActive("/event") ? 'mm-active' : ''}>
            <NavLink to="/event" className={({ isActive }) =>
              `waves-effect ${isActive ? 'active' : ''}`
            }>
              <i className="fas fa-calendar-alt"></i>
              <span className="ms-2">Event</span>
            </NavLink>
          </li>
          <li className={isActive("/coreTeam") ? 'mm-active' : ''}>
            <NavLink to="/coreTeam" className={({ isActive }) =>
              `waves-effect ${isActive ? 'active' : ''}`
            }>
              <i className="fas fa-users-cog"></i>
              <span className="ms-2">Core Team</span>
            </NavLink>
          </li>
          <li className={isActive("/contributionTeam") ? 'mm-active' : ''}>
            <NavLink to="/contributionTeam" className={({ isActive }) =>
              `waves-effect ${isActive ? 'active' : ''}`
            }>
              <i className="fas fa-hands-helping"></i>
              <span className="ms-2">Contribution Team</span>
            </NavLink>
          </li>
          <li className={isActive("/partnerRequest") ? 'mm-active' : ''}>
            <NavLink to="/partnerRequest" className={({ isActive }) =>
              `waves-effect ${isActive ? 'active' : ''}`
            }>
              <i className="fas fa-handshake"></i>
              <span className="ms-2">PartnerRequest</span>
            </NavLink>
          </li>
          <li className={isActive("/fees") ? 'mm-active' : ''}>
            <NavLink to="/fees" className={({ isActive }) =>
              `waves-effect ${isActive ? 'active' : ''}`
            }>
              <i className="fas fa-wallet"></i>
              <span className="ms-2">Fees</span>
            </NavLink>
          </li>

          {/* Uncomment if needed
          <li className={isActive("/growthPartner") ? 'mm-active' : ''}>
            <NavLink to="/growthPartner" className={({ isActive }) =>
              `waves-effect ${isActive ? 'active' : ''}`
            }>
              <i className="fas fa-calendar-alt"></i>
              <span className="ms-2">Growth Partner</span>
            </NavLink>
          </li>
          <li className={isActive("/growthPartnerCluster") ? 'mm-active' : ''}>
            <NavLink to="/growthPartnerCluster" className={({ isActive }) =>
              `waves-effect ${isActive ? 'active' : ''}`
            }>
              <i className="fas fa-calendar-alt"></i>
              <span className="ms-2">Growth Partner Cluster</span>
            </NavLink>
          </li>
          */}

          {/* Settings Section */}
          <li className={isActive("/setting") ? 'mm-active' : ''}>
            <NavLink to="/setting" className={({ isActive }) =>
              `waves-effect ${isActive ? 'active' : ''}`
            }>
              <i className="dripicons-gear"></i>
              <span>Master Settings</span>
            </NavLink>
          </li>
          {/* Uncomment if needed
          <li className={isActive("/ticket") ? 'mm-active' : ''}>
            <NavLink to="/ticket" className={({ isActive }) =>
              `waves-effect ${isActive ? 'active' : ''}`
            }>
              <i className="fas fa-ticket-alt"></i>
              <span>Ticket</span>
            </NavLink>
          </li>
          */}
          <li className={isActive("/report") ? 'mm-active' : ''}>
            <NavLink to="/report" className={({ isActive }) =>
              `waves-effect ${isActive ? 'active' : ''}`
            }>
              <i className="fas fa-file-alt"></i>
              <span>Activity</span>
            </NavLink>
          </li>
          {/* Uncomment if needed
          <li className={isActive("/notification") ? 'mm-active' : ''}>
            <NavLink to="/notification" className={({ isActive }) =>
              `waves-effect ${isActive ? 'active' : ''}`
            }>
              <i className="dripicons-gear"></i>
              <span>Notification</span>
            </NavLink>
          </li>
          */}
          <li className={isActive("/mobileSetting") ? 'mm-active' : ''}>
            <NavLink to="/mobileSetting" className={({ isActive }) =>
              `waves-effect ${isActive ? 'active' : ''}`
            }>
              <i className="fas fa-mobile-alt"></i>
              <span>Mobile Settings</span>
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;